import React, { useState, useEffect } from "react";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import Footer from "../../../components/common/Footer";
import { firestore } from "../../../Config/FbConfig";
import { doc, onSnapshot, collection } from "firebase/firestore";

const CyberContact = () => {
  const [docName] = useState("Contact");
  const [data, setData] = useState(["Loading"]);

  console.log(data);

  useEffect(() => {
    const uid = "cyber";
    const docRef = doc(collection(firestore, uid), docName);
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const Data = [];
        Object.entries(docSnap.data()).forEach(([key, value]) => {
          Data.push({
            Id: key,
            ...value,
            FilterData: JSON.stringify(value),
          });
        });
        setData(Data);
      } else {
        setData([]);
      }
    });
    return () => unsubscribe();
  }, [docName]);

  return (
    <div>
      {/* Header */}
      <Header />

      {/* Banner */}
      <Banner
        title="CSE (IOT & Cyber Security Including Blockchain Technology)"
        image="banners/department-cse.jpg"
      />

      {/* Content */}
      <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
        <div className="container-xl">
          <div className="row">
            <div className="col-lg-9 content-area order-lg-4">
              <div className="section-title with-desc text-left clearfix">
                <div className="title-header">
                  <h4 className="title">Contact</h4>
                </div>
              </div>
              <div className="row">
                {data?.map((item, index) => (
                  <div className="col-md-6 col-sm-12 paddingtop-2" key={index}>
                    <div className="featured-icon-box style2 left-icon icon-align-top">
                      <div className="featured-icon">
                        <div className="ttm-icon ttm-bgcolor-skincolor ttm-icon_element-size-md rounded-circle">
                          <i className="fa fa-phone" />
                        </div>
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h6>{item.Role}</h6>
                        </div>
                        <div
                          className="featured-desc"
                          style={{ lineHeight: "21px", marginTop: "5px" }}
                        >
                          <p>{item.Name} </p>
                          <p>Designation : {item.Designation} </p>
                          <p>E-mail Id : {item.EmailId}</p>
                          <p>Contact Number : {item.PhoneNumber}</p>
                          <p>Department : {item.Department}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-3 widget-area">
              <DepartmentSidebar department="cyber" />
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default CyberContact;
